import { trackConfig, type IFramework } from '@/framework';
import {
    LayerType,
    TextAlignType,
    TextVerticalAlign,
    type ILayerProps,
    type IVectorLayerProps,
    type VectorTextInfo,
} from '@/version-types';
import { pushHistory, updateLayer } from '../utils';

export interface ITextAlignment {
    /**
     * 设置水平对齐方式
     * @param layerID - 图层 id
     * @param align - 水平对齐方式
     * @returns
     */
    setTextAlign(layerID: string, value: TextAlignType): ILayerProps | void;

    /**
     * 设置垂直对齐方式
     * @param layerID - 图层 id
     * @param align - 垂直对齐方式
     * @returns
     */
    setVerticalAlign(layerID: string, value: TextVerticalAlign): ILayerProps | void;
}

export class TextAlignment implements ITextAlignment {
    constructor(private framework: IFramework) {}

    private set(layerID: string, kind: 'textAlign', value: TextAlignType): ILayerProps | void;
    private set(layerID: string, kind: 'verticalAlign', value: TextVerticalAlign): ILayerProps | void;
    private set(layerID: string, kind: 'textAlign' | 'verticalAlign', value: TextAlignType | TextVerticalAlign) {
        const prevLayer = this.framework.getLayer(layerID, true);
        if (!prevLayer || prevLayer.layerType !== LayerType.VECTOR_LAYER) return;

        const layerData = prevLayer.data as IVectorLayerProps;
        const { textInfo } = layerData;

        if (!textInfo) return;

        if (textInfo[kind] === value) return;

        const nextTextInfo: VectorTextInfo = { ...textInfo, [kind]: value };
        const nextLayerData: IVectorLayerProps = { ...layerData, textInfo: nextTextInfo };
        const nextLayer: ILayerProps = { ...prevLayer, data: nextLayerData };

        updateLayer(this.framework, nextLayer);
        pushHistory(this.framework, prevLayer, nextLayer, trackConfig[LayerType.TEXT_LAYER].textAlign);

        return nextLayer;
    }

    setTextAlign(layerID: string, value: TextAlignType) {
        return this.set(layerID, 'textAlign', value);
    }

    setVerticalAlign(layerID: string, value: TextVerticalAlign) {
        return this.set(layerID, 'verticalAlign', value);
    }
}
